import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGeoloc = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_264_34723)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M0.265595 4.24952C0.12167 1.94672 1.95052 0 4.2578 0H18.7422C20.8544 0 22.6026 1.64235 22.7344 3.75049L23.7344 19.7505C23.8783 22.0533 22.0495 24 19.7422 24H5.2578C3.14555 24 1.39735 22.3577 1.26559 20.2495L0.265595 4.24952Z",
			fill: "#FFD28F"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M9.60398 18.5221C8.50516 20.9668 6.85693 9.28639 6.85693 7.65658C6.85693 6.35273 7.77262 6.93222 8.23046 7.38495L17.2957 13.361C18.7753 14.3364 16.4918 14.2173 14.2206 13.9862M9.60398 18.5221C9.85964 17.9533 10.1171 17.3009 10.363 16.6753M9.60398 18.5221C9.87459 18.0724 10.2361 17.4847 10.6215 16.8785M12.8569 13.849C13.0425 13.8605 13.2402 13.8813 13.4498 13.9043C13.7029 13.9321 13.9616 13.9599 14.2206 13.9862M12.8569 13.849C12.5437 13.8296 12.2647 13.8367 12.0206 13.9043M12.8569 13.849C12.5874 13.9348 11.754 15.1254 10.9435 16.3767M10.363 16.6753L10.3873 16.6135C10.8337 15.4779 11.2404 14.4433 11.5269 14.1759C11.6715 14.041 11.8361 13.9554 12.0206 13.9043M10.363 16.6753L12.0206 13.9043M14.2206 13.9862C13.6814 13.9314 12.3224 14.3541 10.9435 16.3767M10.6215 16.8785C10.7275 16.7118 10.8353 16.5437 10.9435 16.3767M10.6215 16.8785C10.7287 16.7012 10.8362 16.5341 10.9435 16.3767",
			stroke: "#102D2D",
			strokeWidth: 1.2,
			strokeLinecap: "round"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_264_34723",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgGeoloc;
